import { useTranslation } from "react-i18next";
import logoBorneEtEaux from "../assets/img/logo-borne_et_eaux.png";
import logoVNF from "../assets/img/logo-vnf-monochrome.svg";
import logoHaropa from "../assets/img/logo-haropa.svg";
import { useEffect, useState, useRef } from "react";

const SplashLoader = ({ show = false, onClose }) => {
    // timer values
    const delay = 3000;
    const radius = 36;
    const strokeWidth = 4;
    const padding = 4;
    const center = radius + padding;
    const svgSize = center * 2;
    const circ = 2 * Math.PI * radius;

    const timeoutIdRef = useRef(null);
    const intervalIdRef = useRef(null);
    const [strokeDashoffset, setStrokeDashoffset] = useState(circ);
    const [showSplash, setShowSplash] = useState(false);
    const [progress, setProgress] = useState(0);
    const { t } = useTranslation();

    useEffect(() => {
        function startProgress() {
            setTimeout(() => setShowSplash(true), 0);

            setStrokeDashoffset(circ);

            setTimeout(() => {
                setStrokeDashoffset(0);
            }, 20);

            setProgress(0);

            const progressInterval = Math.floor(delay / 100);

            const newIntervalId = setInterval(() => {
                setProgress((prev) => {
                    if (prev < 100) {
                        return prev + 1;
                    } else {
                        clearInterval(newIntervalId);
                        intervalIdRef.current = null;

                        timeoutIdRef.current = setTimeout(() => {
                            setShowSplash(false);
                            onClose && onClose();
                        }, 100);

                        return 100;
                    }
                });
            }, progressInterval);

            if (intervalIdRef.current !== null) {
                clearInterval(intervalIdRef.current);
            }
            intervalIdRef.current = newIntervalId;
        }

        if (show) {
            startProgress();
        } else {
            const hideTimeout = setTimeout(() => {
                setShowSplash(false);
                setStrokeDashoffset(circ);
                setProgress(0);
            }, 0);

            if (timeoutIdRef.current !== null) {
                clearTimeout(timeoutIdRef.current);
                timeoutIdRef.current = null;
            }
            if (intervalIdRef.current !== null) {
                clearInterval(intervalIdRef.current);
                intervalIdRef.current = null;
            }

            return () => {
                clearTimeout(hideTimeout);
            };
        }

        return () => {
            if (timeoutIdRef.current !== null) {
                clearTimeout(timeoutIdRef.current);
                timeoutIdRef.current = null;
            }
            if (intervalIdRef.current !== null) {
                clearInterval(intervalIdRef.current);
                intervalIdRef.current = null;
            }
        };
    }, [onClose, show, delay, circ]);

    return showSplash ? (
        <div className={`splash-loader${showSplash ? " active" : ""}`}>
            <div className="splash-loader__content">
                <img src={logoBorneEtEaux} alt="Borne et Eaux" />
                <div className="splash-loader__credits">
                    <p>{t("A service developped by ...")}</p>
                    <div>
                        <img src={logoVNF} alt="VNF" />
                        <img src={logoHaropa} alt="Haropa" />
                    </div>
                </div>
            </div>
            <div
                className="splash-loader__timer"
                style={{ width: svgSize, height: svgSize }}
            >
                <svg
                    className="splash-loader__svg"
                    width={svgSize}
                    height={svgSize}
                    viewBox={`0 0 ${svgSize} ${svgSize}`}
                    preserveAspectRatio="xMidYMid meet"
                >
                    <circle
                        className="splash-loader__svg__animated-circle"
                        r={radius}
                        cx={center}
                        cy={center}
                        fill="none"
                        strokeWidth={strokeWidth}
                        strokeDasharray={circ}
                        strokeDashoffset={strokeDashoffset}
                        transform={`rotate(-90 ${center} ${center})`}
                        style={{ transition: `${delay}ms linear` }}
                    />
                    <circle
                        className="splash-loader__svg__fixed-circle"
                        r={radius + 2}
                        cx={center}
                        cy={center}
                        fill="none"
                        strokeWidth="2"
                    />
                    <text
                        className="splash-loader__svg__progress"
                        x={center}
                        y={center}
                        textAnchor="middle"
                        dominantBaseline="middle"
                    >
                        {progress}%
                    </text>
                </svg>
            </div>
        </div>
    ) : (
        <></>
    );
};

export default SplashLoader;
